<script setup lang="ts">
import type { INewsItemCategoryDTO } from '~/shared/api/client/news/news.dto';

/*
  Позиционирование задаёт карточка-хозяин: класс с координатами прилетает
  снаружи через $attrs. Ссылкой значок намеренно не является — карточки,
  в которые он встраивается, сами обёрнуты в ссылку, а <a> внутри <a>
  невалидна.
*/
const props = defineProps<{
  category?: INewsItemCategoryDTO | null;
  withLabel?: boolean;
  muted?: boolean;
}>();

const isVisible = computed(() =>
  Boolean(
    props.category?.is_partner && props.category.image_category?.file_url,
  ),
);
</script>

<template>
  <span v-if="isVisible" :class="$style.badge">
    <span v-if="withLabel" :class="$style.badge__label">
      {{ category?.name }}
    </span>
    <img
      :class="[$style.badge__icon, { [$style.badge__icon_muted!]: muted }]"
      :src="category?.image_category?.file_url"
      :alt="category?.name"
    />
  </span>
</template>

<style lang="scss" module>
.badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;

  &__label {
    @include text_caption2_caps;
    color: var(--color-gray-text);
  }

  &__icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
    flex-shrink: 0;

    /*
      Логотип тега — растровая картинка, цветом её не переопределить.
      brightness(0) гасит её в чёрный, сохраняя прозрачность, а invert
      поднимает до #999999 — ровно цвет подписи, независимо от того,
      какого цвета логотип загрузили в тег.
    */
    &_muted {
      filter: brightness(0) invert(0.6);
    }
  }
}
</style>
